import React from 'react';
import { Radio, CalendarClock } from 'lucide-react';
import LiveCard from '../LiveCard';

/**
 * VetrinaLiveSection — Phase F5. Reuses the EXISTING Live system/cards:
 * A. LIVE ORA (gating/ticket flow untouched) · B. programmate (booking
 * esistente) · C. storico compatto.
 */
const VetrinaLiveSection = ({ liveNow, scheduledLives, pastLives, onChange }) => {
  if (!liveNow && scheduledLives.length === 0 && pastLives.length === 0) return null;
  return (
    <section className="mt-8" data-testid="vetrina-live-section">
      <h2 className="mb-3 flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-red-500">
        <Radio className="h-4 w-4" /> Live
      </h2>
      {liveNow && (
        <div className="mb-3" data-testid="vetrina-live-now">
          <p className="mb-1.5 flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider text-red-500">
            <span className="h-2 w-2 animate-pulse rounded-full bg-red-500" /> Live ora
          </p>
          <LiveCard live={liveNow} actionable onChange={onChange} />
        </div>
      )}
      {scheduledLives.length > 0 && (
        <div className="mb-3" data-testid="vetrina-live-scheduled">
          <p className="mb-1.5 flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider text-muted-foreground">
            <CalendarClock className="h-3.5 w-3.5" /> In programma
          </p>
          <div className="flex flex-col gap-2">
            {scheduledLives.map((l) => (
              <LiveCard key={l.id} live={l} actionable onChange={onChange} />
            ))}
          </div>
        </div>
      )}
      {pastLives.length > 0 && (
        <div data-testid="vetrina-live-past">
          <p className="mb-1.5 text-[11px] font-bold uppercase tracking-wider text-muted-foreground">
            Storico ({pastLives.length})
          </p>
          <div className="flex flex-col gap-2 opacity-80">
            {pastLives.slice(0, 5).map((l) => (
              <LiveCard key={l.id} live={l} compact />
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default VetrinaLiveSection;
